"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveButtonText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
exports.SaveButtonText = styled_components_1.default.span `
	margin-left: 0.5rem;

	${(0, styled_breakpoints_1.down)('lg')} {
		display: none;
	}
`;
